import React from 'react';
import PropTypes from 'prop-types';
import { Button, MobileSectionLink, See3D } from './SectionButton.styled';
import MatterportIcon from '../MatterportIcon/MatterportIcon';

const SectionButton = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  matterportUrl,
}) => {
  return (
    <div>
      <Button
        type="button"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <MatterportIcon />
        <See3D>See it in 3D</See3D>
      </Button>
      <MobileSectionLink
        href={matterportUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <MatterportIcon />
        <div>See it in 3D</div>
      </MobileSectionLink>
    </div>
  );
};

SectionButton.propTypes = {
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  matterportUrl: PropTypes.string,
  gaLabel: PropTypes.string,
};

SectionButton.defaultProps = {
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  matterportUrl: '',
  gaLabel: '',
};

export default SectionButton;
